import React from "react";
import { Route, Switch } from "react-router-dom";
import ConsultarEventos from "./pages/ConsultarEventos";

import "./assets/consultar-eventos.scss";

const ConsultarEventosPage: React.FC = () => {
  return (
    <Switch>
      <Route
        path="/consultar-eventos/inicio"
        exact={true}
        component={ConsultarEventos}
      />
    </Switch>
  );
};

export default ConsultarEventosPage;
